import {
  GET_USER,
  // ADD_MENU,
  // PUT_MENU,
  // DELETE_MENU,
  API_ERROR,
  GET_USER_SUCCESSFUL,
  USER_CHANGE_PASSWORD,
} from "./actionTypes";

export const getUser = (user) => {
  return {
    type: GET_USER,
    payload: { user },
  };
};

export const getUserSuccessful = (userData) => {
  return {
    type: GET_USER_SUCCESSFUL,
    payload: { userData },
  };
};
export const ChangePasswordSubmit = (data, history) => {
  return {
    type: USER_CHANGE_PASSWORD,
    payload: { data, history },
  };
};

// export const add_menu = (menu) => {
//   return {
//     type: ADD_MENU,
//     payload: menu,
//   };
// };

// export const put_menu = (menu, history) => {
//   return {
//     type: PUT_MENU,
//     payload: { menu, history },
//   };
// };

// export const delete_menu = (menu) => {
//   return {
//     type: DELETE_MENU,
//     payload: menu,
//   };
// };

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};
